import { AnyExtension } from '@tiptap/core'

import {
  BaseKit,
  Columns,
  History,
  Heading,
  FormatPainter,
  Clear,
  FontSize,
  FontFamily,
  Bold,
  Italic,
  Underline,
  Strike,
  Link,
  MoreMark,
  Color,
  Highlight,
  BackgroundBlock,
  BulletList,
  OrderedList,
  TextAlign,
  Indent,
  LineHeight,
  Blockquote,
  HorizontalRule,
  Border,
  SlashCommand,
  Fullscreen,
  Preview,
  Printer,
  Image,
  ImageUpload,
  VariableNode,
  IfBlock,
  ForBlock,
  TableLoop,
  DynamicConstructs,
} from './extensions'

const minimalEditorExtensions: AnyExtension[] = [
  BaseKit.configure(),
  History,
  Columns,
  FontSize.configure({ spacer: true }),
  Bold.configure({ spacer: true }),
  Italic,
  Underline,
  Strike,
  Color.configure({ spacer: true }),
  Highlight,
  BackgroundBlock,
  Link.configure({ spacer: true }),
  BulletList,
  OrderedList,
  Blockquote,
  Border,
]

const fullEditorExtensions = [
  BaseKit.configure({
    placeholder: {
      showOnlyCurrent: true,
    },
  }),
  History,
  Columns,
  FormatPainter,
  Clear,
  Heading.configure({ spacer: true }),
  FontSize,
  FontFamily,
  Bold,
  Italic,
  Underline,
  Strike,
  MoreMark,
  Color.configure({ spacer: true }),
  Highlight,
  BackgroundBlock.configure({ spacer: true }),
  BulletList,
  OrderedList,
  TextAlign.configure({ types: ['heading', 'paragraph', 'image'], spacer: true }),
  Indent,
  LineHeight,
  Link,
  Image,
  ImageUpload.configure({
    upload: (files: File) => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(URL.createObjectURL(files))
        }, 3000)
      })
    },
  }),
  Blockquote,
  SlashCommand,
  HorizontalRule,
  Border.configure({ spacer: true }),
  Fullscreen.configure({ spacer: true }),
  VariableNode,
  IfBlock,
  ForBlock,
  TableLoop,
  DynamicConstructs,
  Preview,
  Printer,
]

export { minimalEditorExtensions, fullEditorExtensions }
